/* eslint-disable @typescript-eslint/camelcase */
// tslint:disable:trailing-comma

import * as nls from "vscode-nls";
import { instance } from "./config/serverConfig";

// WARNING! every time this file changes, make sure to call locprepare.bat or pack.bat
const __filename: string = "./ResourceStrings.js"; // un-comment for PRODUCTION, comment for testing

const isPseudo = false;
function format(message: string, args: any[]): string {
    let result: string;

    if (isPseudo) {
        // FF3B and FF3D is the Unicode zenkaku representation for [ and ]
        message = '\uFF3B' + message.replace(/[aouei]/g, '$&$&') + '\uFF3D';
    }

    if (args.length === 0) {
        result = message;
    } else {
        result = message.replace(/\{(\d+)\}/g, (match, rest) => {
            const index = rest[0];
            const arg = args[index];
            let replacement = match;
            if (typeof arg === 'string') {
                replacement = arg;
            } else if (typeof arg === 'number' || typeof arg === 'boolean' || arg === void 0 || arg === null) {
                replacement = String(arg);
            }
            return replacement;
        });
    }
    return result;
}

const DEFAULT_LOCALE: string = "en";
// @TODO: Replace with new equivalent
// let localize = nls.config({ locale: DEFAULT_LOCALE, cacheLanguageResolution: false })(__filename);
let localize = (info: any, message: string, ...args: any) => "!7iX0V!" + message + " ýÛöÑéÎå!"; //comment for production
localize = (info: any, message: string, ...args: any) => format(message, args); //comment for production

export class ResourceStrings {
    public static config(locale: string, cache = false) {
        // @TODO: Replace with new equivalent
        // localize = nls.config({ locale: locale, cacheLanguageResolution: cache })(__filename);
        ////localize = (info: any, message: string, ...args: any) => "!7iX0V!" + message + " ýÛöÑéÎå!"; //comment for production
        localize = (info: any, message: string, ...args: any) => format(message, args); //comment for production
    }

    public static windowTitle() {
        return localize({
            key: "General.Window.Title",
            comment: ["Title of main window"]
        },
            "Visual Studio Feedback");
    }

    public static noMatch(url: string) {
        return localize({
            key: "General.Window.NoMatch",
            comment: ["Message displayed when invalid url is used; {0} - url value"]
        },
            "Error 404: No match found for '{0}'", url);
    }

    public static submitPostViewTitle(userName: string) {
        return localize({
            key: "ReportProblem.Page.Title.DescribeIssue",
            comment: ["Title showing up at the top on submit post page; {0} - logged in person's name"]
        },
            "Hi {0}, describe your issue", userName);
    }

    public static joinOngoingDiscussionTitle() {
        return localize({
            key: "ReportProblem.Page.Title.JoinOngoingDiscussion",
            comment: ["Title showing up at the top on submit post page to join ongoing discussion."]
        },
            "Join an ongoing discussion");
    }

    public static joinOngoingDiscussionText() {
        return localize({
            key: "ReportProblem.Page.Text.JoinOngoingDiscussion",
            comment: ["Text showing up below title on submit post page to join ongoing discussion to track solution."]
        },
            "Join an ongoing discussion to track the solution");
    }

    public static providePostDetailsText() {
        return localize({
            key: "ReportProblem.providePostDetails.Text",
            comment: ["Text showing below the top banner on submit post page asking for post details."]
        },
            "Please provide a clear title");
    }

    public static provideCommentDetailsText() {
        return localize({
            key: "ReportProblem.providePostDetails.Text",
            comment: ["Text showing below the top banner on submit vote page asking for comment details."]
        },
            "Please provide clear details for this vote.");
    }

    public static howToMakeGoodReport() {
        return localize({
            key: "ReportProblem.howToMakeGoodReport.Text",
            comment: ["Text indicating how to make good report"]
        },
            "How to make a good report");
    }

    public static secured() {
        return localize({
            key: "ReportProblem.secured.Text",
            comment: ["Text indicating session is secure"]
        },
            "Secured");
    }

    public static howToMakeGoodReportTips() {
        return localize({
            key: "ReportProblem.howToMakeGoodReportTips.Text",
            comment: ["Text indicating tips for how to make good report"]
        },
            "Tips: How to make a good report");
    }

    public static seeExampleText() {
        return localize({
            key: "ReportProblem.seeExample.Text",
            comment: ["Link showing below the top banner on submit post page for example."]
        },
            "see example.");
    }

    public static shareResearchInCommentText() {
        return localize({
            key: "ReportProblem.shareResearchInComment.Text",
            comment: ["Text showing below the top banner on submit comment page asking for sharing research."]
        },
            "Share your research in your comment.");
    }

    public static yourResponse() {
        return localize({
            key: "ReportProblem.yourResponse.Text",
            comment: ["Text showing above Markup editor asking for response."]
        },
            "Your response");
    }

    public static postTitlePlaceholder() {
        return localize({
            key: "ReportProblem.postTitle.placeholder.Text",
            comment: ["Placeholder text for post title textbox."]
        },
            "Please add the title here (required)");
    }

    public static weAreImproving() {
        return localize({
            key: "General.WorkingOn.Text",
            comment: ["Text showing up on main UI to signify we're in Preview"]
        },
            "We're still working to improve this experience.");
    }

    public static searchResultsTitle(resultsCount: number) {
        return localize({
            key: "General.Search.Results.Title",
            comment: ["Title for search results. Prameter represents mumber of search results"]
        },
            "We found {0} similar items. You can join an ongoing discussion instead of creating a new one", resultsCount);
    }

    public static searchResultsLoaded(resultsCount: number) {
        return localize({
            key: "General.Search.ResultsLoaded.Title",
            comment: ["Status message to inform user when search results are loaded. Parameter 'resultsCount' is the number of results loaded so far."]
        },
            "{0} search results have been loaded", resultsCount);
    }

    public static search() {
        return localize({
            key: "General.Search.Text",
            comment: ["Text showing up on main UI on search-label"]
        },
            "Search");
    }

    public static youHaveSomeProblems(problemCount: number) {
        return localize({
            key: "MainView.Search.youHaveSomeProblems",
            comment: ["Notification showing that a person has problems needing attention"]
        },
            "You have {0} problems that need your attention.", problemCount);
    }

    public static vsTeamNeedsMoreInfo() {
        return localize({
            key: "DetailsView.Text.vsTeamNeedsMoreInfo",
            comment: ["Header explaining the user they need to respond to request from Visual Studio"]
        },
            "The Visual Studio team needs more information about this problem.");
    }

    public static vsTeamNeedsMoreInfoMessage(userName: string) {
        return localize({
            key: "DetailsView.Text.vsTeamNeedsMoreInfoMessage",
            comment: ["Message in post details explaining the user they need to respond to request from Visual Studio"]
        },
            "Hi, {0}, we need more info on the subject.", userName);
    }

    public static fillMissingInfoLink() {
        return localize({
            key: "DetailsView.Text.fillMissingInfoLink",
            comment: ["link for 'fill the missing info'"]
        },
            "Please fill the missing info");
    }

    public static viewRequestAndRespond() {
        return localize({
            key: "DetailsView.Text.viewRequestAndRespond",
            comment: ["Button text that shows up request and response dialog for more info"]
        },
            "View their request and respond");
    }

    public static alreadyProvidedNmi() {
        return localize({
            key: "DetailsView.Text.alreadyProvidedNmi",
            comment: ["Header explaining to the user that they have already replied, but they can provide more info if they want/need"]
        },
            "Thanks for providing more information!");
    }

    public static addNmiDetails() {
        return localize({
            key: "DetailsView.Text.addNmiDetails",
            comment: ["Button text that shows up request and response dialog for more info"]
        },
            "Add new details (optional)");
    }

    public static provideMoreInfo() {
        return localize({
            key: "Problem.Button.provideMoreInfo",
            comment: ["Button text to provide more info"]
        },
            "Provide more info");
    }

    public static viewProblems() {
        return localize({
            key: "MainView.Search.viewProblems",
            comment: ["Button text"]
        },
            "View problems");
    }

    public static reportNew() {
        return localize({
            key: "General.reportNew.Text",
            comment: ["Text showing up on main UI on reportAProblem-label"]
        },
            "Report new problem");
    }

    public static suggestNew() {
        return localize({
            key: "General.suggestNew.Text",
            comment: ["Text showing up on main UI on suggestAFeature-button"]
        },
            "Request a feature");
    }

    public static noVSInstance() {
        return localize({
            key: "General.noVSInstance.Text",
            comment: ["Text showing up on main UI if the parent VS instance is closed"]
        },
            "A running instance of Visual Studio is required in order to report feedback for Visual Studio. Please close this window and reopen from a running instance of Visual Studio.");
    }

    public static notAcceptingFeedback() {
        return localize({
            key: "General.notAcceptingFeedback.Text",
            comment: ["Text showing up on main UI for deprecated (old/preview) builds"]
        },
            "We’re sorry but we’re no longer accepting feedback for this version of Visual Studio.");
    }

    public static pleaseUpdateVsLink() {
        return localize({
            key: "General.pleaseUpdateVsLink.Text",
            comment: ["Text link showing up on main UI for deprecated (old/preview) builds"]
        },
            "Please upgrade to the latest version");
    }

    public static warningDialogTitle() {
        return localize({
            key: "WarningDialog.WarningDialogTitle.Text",
            comment: ["Title for the dialog showing up if the user tries to close before Record is done"]
        },
            "Recording Warning");
    }

    public static warnStillRecording() {
        return localize({
            key: "WarningDialog.warnStillRecording.Text",
            comment: ["Text for the dialog showing up if the user tries to close before Record is done"]
        },
            "Recording is still in progress! Please stop recording before exit!");
    }

    public static dialogSysLogsTitle() {
        return localize({
            key: "dialogSysLogs.title",
            comment: ["Dialog window title"]
        },
            "System logs confirmation");
    }

    public static dialogSysLogsExplanation(privacyStatement: string, dataWeCollect: string) {
        return localize({
            key: "dialogSysLogs.explanationText",
            comment: ["Explanation text. {0} - replaced with link to text that reads 'Privacy Statement'; {1} - replaced with link that reads 'Data we collect'"]
        },
            // tslint:disable-next-line:max-line-length
            "Excluding system logs from your report can significantly reduce Microsoft’s ability to understand and respond to the issue. If submitted,  system logs will be kept private to Microsoft. They are not shared on Developer Community. See {0} and {1}.", privacyStatement, dataWeCollect);
    }

    public static includeSystemLogs() {
        return localize({
            key: "dialogSysLogs.includeSystemLogs.Text",
            comment: ["Button text"]
        },
            "Include system logs");
    }

    public static removeSystemLogs() {
        return localize({
            key: "dialogSysLogs.removeSystemLogs.Text",
            comment: ["Button text for removing system logs when submitting problem report"]
        },
            "No, remove from report");
    }

    public static votes() {
        return localize({
            key: "ProblemSmall.Votes.Text",
            comment: ["Text showing up on main UI to show the no of votes the problem has"]
        },
            "Votes");
    }

    public static answers() {
        return localize({
            key: "ProblemSmall.Answers.text",
            comment: ["Text showing up on main UI to show the no of solutions the problem has"]
        },
            "Solutions");
    }

    public static solutionsAndVotes(solutionCount: number, voteCount: number) {
        return localize({
            key: "ProblemSmall.SolutionsVotes.ScreenReaderText",
            comment: ["Text read by screen reader when tabbing through issue. {0} and {1} are numbers - count of solutions and votes"]
        },
            "{0} solutions, {1} votes", solutionCount, voteCount);
    }

    public static submittedVote() {
        return localize({
            key: "ProblemSmall.SubmittedVote.Text",
            comment: ["Text showing up on main UI to show that the vote was submitted"]
        },
            "Submitted");
    }

    public static refresh() {
        return localize({
            key: "General.refresh.Text",
            comment: ["Text for refresh button"]
        },
            "Refresh");
    }

    public static openInNewTab() {
        return localize({
            key: "General.openInNewTab.Text",
            comment: ["Text for open in new tab button"]
        },
            "Open in new tab");
    }

    public static selectAPage() {
        return localize({
            key: "General.selectAPage.Text",
            comment: ["Text to show in nav bar drop down when no page from that list is selected"]
        },
            "Select a page");
    }

    public static loading() {
        return localize({
            key: "General.Loading.Text",
            comment: ["Text showing up on main UI to show that we are loading"]
        },
            "Loading...");
    }

    public static loadingSuccess() {
        return localize({
            key: "General.Text.loadingSuccess",
            comment: ["Text showing up on main UI to show that load completed"]
        },
            "Results loaded.");
    }

    public static tags() {
        return localize({
            key: "General.TitleTags.Text",
            comment: ["Title text for the tags filter"]
        },
            "Topics:");
    }

    public static firstToReportProblem() {
        return localize({
            key: "SearchResult.Problem.FirstToReport.Text",
            comment: ["Text showing up on main UI to show the search returned no results"]
        },
            "Be the first to report this issue");
    }

    public static firstToReportIdea() {
        return localize({
            key: "SearchResult.Idea.FirstToReport.Text",
            comment: ["Text showing up on main UI to show the search returned no results"]
        },
            "Be the first to suggest this feature");
    }

    public static noItemsFound() {
        return localize({
            key: "SearchResult.noItemsFound.Text",
            comment: ["Text showing for no results"]
        },
            "No items found");
    }

    public static privateBuild() {
        return localize({
            key: "SearchResult.PrivateBuild.Text",
            comment: ["Explanation that private builds are not supported yet"]
        },
            "Bear with us while we improve your experience. Full feedback features are not supported in this build except reporting a new problem.");
    }

    public static searchError() {
        return localize({
            key: "SearchResult.SearchError.Text",
            comment: ["Text showing up on main UI to show there was an error while searching"]
        },
            "Error searching, please try again later");
    }

    public static errorUnknown() {
        return localize({
            key: "Problem.Error.Unknown",
            comment: ["Uknown error text"]
        },
            "Unknown");
    }

    public static errorTextRangeBetween(minLength: number, maxLength: number) {
        return localize({
            key: "General.Error.textRangeBetween",
            comment: ["Error text shown when value is not between specified parameters in length."]
        },
            "Value must be {0} to {1} characters long", minLength, maxLength);
    }

    public static charactersLeft(characterCount: number) {
        return localize({
            key: "General.Error.textRangeBetween",
            comment: ["Message shown next to an input text field to indicate how many more characters (characterCount parameter) can be typed in it."]
        },
            "{0} characters left", characterCount);
    }

    public static errorTextLongerThan(minLength: number) {
        return localize({
            key: "General.Error.textLongerThan",
            comment: ["Error text shown when value is less than specified parameter in length."]
        },
            "Value must be at least {0} characters long", minLength);
    }

    public static errorTitleAndDescriptionBeDifferent() {
        return localize({
            key: "General.Error.titleAndDescriptionBeDifferent",
            comment: ["Error text shown when feedback title and description are same"]
        },
            "Title and description should be different");
    }

    public static feedbackFromTheEngineeringTeam() {
        return localize({
            key: "Guidance.dialog.Title",
            comment: ["Title for the guidance dialog"]
        },
            "Tips for Meaningful Feedback");
    }

    public static guideWeReceiveHelpUs() {
        return localize({
            key: "Guidance.dialog.weReceive",
            comment: ["Information text in guidance dialog"]
        },
            "We receive a lot of feedback from developers like you and we appreciate it. To help us improve response times, please read the tips below to make sure that we give you the best experience.");
    }

    public static guideSearchFirst() {
        return localize({
            key: "Guidance.dialog.guideSearchFirst",
            comment: ["Information text in guidance dialog"]
        },
            "Search First");
    }

    public static guideSearchToSaveTime() {
        return localize({
            key: "Guidance.dialog.guideSearchToSaveTime",
            comment: ["Information text in guidance dialog"]
        },
            "Search, vote and comment on the duplicate post to save time.");
    }

    public static guideUseSpecificTitles() {
        return localize({
            key: "Guidance.dialog.guideUseSpecificTitles",
            comment: ["Information text in guidance dialog"]
        },
            "Use Specific Titles");
    }

    public static guideProvideClearTitles() {
        return localize({
            key: "Guidance.dialog.guideProvideClearTitles",
            comment: ["Information text in guidance dialog"]
        },
            "Provide clear titles and details, and share your research to help us understand your post.");
    }

    public static guideClearTitle() {
        return localize({
            key: "Guidance.dialog.guideClearTitle",
            comment: ["Information text in guidance dialog"]
        },
            "Clear Title");
    }

    public static guideReviewSuggestionDescription() {
        return localize({
            key: "Guidance.dialog.guideReviewSuggestionDescription",
            comment: ["Information text in guidance dialog"]
        },
            "If you find your issue already exists, make relevant comments and cast your vote.");
    }

    public static guideReviewSuggestion() {
        return localize({
            key: "Guidance.dialog.guideReviewSuggestion",
            comment: ["Information text in guidance dialog"]
        },
            "Review existing feedback");
    }

    public static guideSeparateIssues() {
        return localize({
            key: "Guidance.dialog.guideSeparateIssues",
            comment: ["Information text in guidance dialog"]
        },
            "Separate Issues");
    }

    public static guideIfYouHaveMultipleProblems() {
        return localize({
            key: "Guidance.dialog.guideIfYouHaveMultipleProblems",
            comment: ["Information text in guidance dialog"]
        },
            "If you have multiple problems, submit multiple reports.");
    }

    public static guideSeparateIdeas() {
        return localize({
            key: "Guidance.dialog.guideSeparateIdeas",
            comment: ["Information text in guidance dialog"]
        },
            "Separate Ideas");
    }

    public static guideIfYouHaveMultipleSuggestions() {
        return localize({
            key: "Guidance.dialog.guideIfYouHaveMultipleSuggestions",
            comment: ["Information text in guidance dialog"]
        },
            "If you have multiple suggestions, submit multiple posts.");
    }

    public static guideSendUsYourSuggestionsText() {
        return localize({
            key: "Guidance.dialog.guideSendUsYourSuggestionsText",
            comment: ["Information text."]
        },
            "Send us your suggestions on how to improve Visual Studio to UserVoice.");
    }

    public static doNotShowThisAgain() {
        return localize({
            key: "Guidance.dialog.doNotShowThisAgain",
            comment: ["Information text in guidance dialog"]
        },
            "Do not show this again");
    }

    public static gotIt() {
        return localize({
            key: "Guidance.button.gotIt",
            comment: ["Button title"]
        },
            "Got it");
    }

    public static needMoreInfo() {
        return localize({
            key: "NeedMoreInfo.needMoreInfo.Title",
            comment: ["Title for the Need More Info dialog"]
        },
            "Need More Info");
    }

    public static needMoreInfoRequestTab() {
        return localize({
            key: "NeedMoreInfo.Request.Tab",
            comment: ["Request tab title"]
        },
            "Request");
    }

    public static needMoreInfoRequestTip() {
        return localize({
            key: "NeedMoreInfo.Request.Tip",
            comment: ["Explanation text for why this dialog is present and what to do next"]
        },
            "The Visual Studio team needs more information about this problem. Please view the request below and respond with the appropriate information.");
    }

    public static needMoreInfoRequestPrefix() {
        return localize({
            key: "NeedMoreInfo.Request.Prefix.Text",
            comment: ["Text preceeding Need more info comment to set context"]
        },
            "Microsoft engineering needs more info about the issue in order to fix this bug.");
    }

    public static moreInfoRequired() {
        return localize({
            key: "NeedMoreInfo.moreInfoRequired.Text",
            comment: ["Title for list of feedback which require more info"]
        },
            "More info required");
    }

    public static needMoreInfoRequestError() {
        return localize({
            key: "NeedMoreInfo.Request.Error",
            comment: ["Text if getting Need More Info comments fails"]
        },
            "Error getting Need More Info request comments");
    }

    public static needMoreInfoRequestExpand() {
        return localize({
            key: "NeedMoreInfo.Request.Expand",
            comment: ["Text on Expand button on Need More Info dialog, Request tab"]
        },
            "All Need More Info comments");
    }

    public static needMoreInfoCommentTip() {
        return localize({
            key: "NeedMoreInfo.comment.Tip",
            comment: ["Explanation text for why enter a comment in Need More info"]
        },
            "Provide commentary supporting the Need More Info request and/or the solution itself.");
    }

    public static needMoreInfoCommentText() {
        return localize({
            key: "NeedMoreInfo.comment.Text",
            comment: ["Placeholder text for the comment in Need More info"]
        },
            "Enter your detailed comments here");
    }

    public static needMoreInfoPleaseWait() {
        return localize({
            key: "NeedMoreInfo.PleaseWait.Text",
            comment: ["Text to let the user know to wait while we send the comment for Need More Info"]
        },
            "Sending your comment, please wait...");
    }

    public static needMoreInfoThanksPrivateBuild() {
        return localize({
            key: "NeedMoreInfo.ThanksPrivateBuild.Text",
            comment: ["Text to let the user know that we sent when the build is private (NDA)"]
        },
            "We've received your Need More Info comment. We will follow up if we have any questions.");
    }

    public static needMoreInfoErrorOnSend() {
        return localize({
            key: "NeedMoreInfo.ErrorOnSend.Text",
            comment: ["Text to let the user know that we couldn't send"]
        },
            "Sorry, we couldn't send your Need More Info comment. Please retry now or sign out, sign in, and try again");
    }

    public static enhanceYourVote() {
        return localize({
            key: "EnhanceYourVote.enhanceYourVote.Title",
            comment: ["Title for the EnhanceYourVote dialog"]
        },
            "Enhance Your Vote");
    }

    public static describeEnhanceYourVoteTitle() {
        return localize({
            key: "EnhanceYourVote.enhanceYourVoteDescription.Title",
            comment: ["Title for Enhance Your Vote description"]
        },
            "What is Enhanced Voting?");
    }

    public static describeEnhanceYourVote1() {
        return localize({
            key: "EnhanceYourVote.enhanceYourVoteDescription.TextFirst",
            comment: ["Text for Enhance Your Vote description- first paragraph"]
        },
            "You can choose to add comments, attach screenshots, step-by-step recordings and other files to your vote.");
    }

    public static describeEnhanceYourVote2() {
        return localize({
            key: "EnhanceYourVote.enhanceYourVoteDescription.TextSecond",
            comment: ["Text for Enhance Your Vote description - second paragraph"]
        },
            "Just follow the Enhance Your Vote sequence by adding a comment and clicking the Next button below.");
    }

    public static notInterestedTitle() {
        return localize({
            key: "EnhanceYourVote.notInterested.Title",
            comment: ["Title for Enhance Your Vote not interested description"]
        },
            "Not interested?");
    }

    public static notInterestedText() {
        return localize({
            key: "EnhanceYourVote.notInterested.Text",
            comment: ["Text for Enhance Your Vote not interested description"]
        },
            "That's OK. Simply cast your vote by clicking on the Just Vote button below.");
    }

    public static reportAProblem() {
        return localize({
            key: "ReportProblem.reportAProblem.Text",
            comment: ["Title for the ReportAProblem dialog"]
        },
            "Report a Problem");
    }

    public static voteForAProblem() {
        return localize({
            key: "ReportProblem.voteForAProblem.Text",
            comment: ["Title for the Vote for a problem dialog"]
        },
            "Vote for a Problem");
    }

    public static suggestAFeature() {
        return localize({
            key: "ReportProblem.suggestAFeature.Text",
            comment: ["Title for the suggestAFeature dialog"]
        },
            "Request a feature");
    }

    public static cantFindExistingProblem() {
        return localize({
            key: "ReportProblem.cantFindExistingProblem.Text",
            comment: ["Info text explaining what to do if couldn't find existing problem dialog"]
        },
            "Searched and didn’t find your feedback?");
    }

    public static publicProblem() {
        return localize({
            key: "ReportProblem.publicProblem.Text",
            comment: ["Info text for the banner explaining that the problem will be public"]
        },
            "Based on your build and profile, your feedback will be PUBLIC and visible to external users");
    }

    // public static privateProblem() {
    //     return localize({
    //         key: "ReportProblem.privateProblem.Text",
    //         comment: ["Info text for the banner explaining that the problem will be private"]
    //     },
    //         "Based on your build and profile, your feedback will be private and visible to Microsoft internal users only");
    // }

    public static describeProblem() {
        return localize({
            key: "ReportProblem.describeProblem.Text",
            comment: ["First transition step in the ReportAProblem dialog"]
        },
            "Describe");
    }

    public static captureProblem() {
        return localize({
            key: "ReportProblem.captureProblem.Text",
            comment: ["Second transition step in the ReportAProblem dialog"]
        },
            "Attachments");
    }

    public static submitProblem() {
        return localize({
            key: "ReportProblem.submitProblem.Text",
            comment: ["Third transition step in the ReportAProblem dialog"]
        },
            "Summary");
    }

    public static titleProblem() {
        return localize({
            key: "ReportProblem.titleProblem.Text",
            comment: ["Placeholder text for title for the Problem"]
        },
            "Title your problem");
    }

    public static titleSuggestion() {
        return localize({
            key: "ReportProblem.titleSuggestion.Text",
            comment: ["Placeholder text for title for the Suggestion"]
        },
            "Title your suggestion");
    }

    public static detailProblem() {
        return localize({
            key: "ReportProblem.detailProblem.Text",
            comment: ["Placeholder text for details for the Problem"]
        },
            "Give as much detail as you can with steps to reproduce your issue");
    }

    public static detailProblemMarkdown() {
        return localize({
            key: "ReportProblem.detailProblemMarkdown.Text",
            comment: ["Placeholder text for details for the Problem"]
        },
            "Styling with Markdown is supported. Give as much detail as you can with steps to reproduce your issue");
    }

    public static detailSuggestion() {
        return localize({
            key: "ReportProblem.detailSuggestion.Text",
            comment: ["Placeholder text for details for the Suggestion"]
        },
            "Give a detailed description of your suggestion");
    }

    public static toolbarBold() {
        return localize({
            key: "ReportProblem.toolbarBold.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Bold (Ctrl+B)");
    }

    public static toolbarItalic() {
        return localize({
            key: "ReportProblem.toolbarItalic.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Italic (Ctrl+I)");
    }

    public static toolbarCode() {
        return localize({
            key: "ReportProblem.toolbarCode.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Code");
    }

    public static toolbarLink() {
        return localize({
            key: "ReportProblem.toolbarLink.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Link (Ctrl+K)");
    }

    public static toolbarQuote() {
        return localize({
            key: "ReportProblem.toolbarQuote.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Quote (Ctrl+Q)");
    }

    public static toolbarImage() {
        return localize({
            key: "ReportProblem.toolbarImage.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Insert Image");
    }

    public static toolbarFile() {
        return localize({
            key: "ReportProblem.toolbarFile.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Attach File");
    }

    public static toolbarNumList() {
        return localize({
            key: "ReportProblem.toolbarNumList.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Numbered List (Ctrl+O)");
    }

    public static toolbarBulList() {
        return localize({
            key: "ReportProblem.toolbarBulList.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Bulleted List (Ctrl+U)");
    }

    public static toolbarHeading3() {
        return localize({
            key: "ReportProblem.toolbarHeading3.Text",
            comment: ["Style formatting command in text editor"]
        },
            "Heading 3 (Ctrl+H)");
    }

    public static publicDisclosureProblem(name: string) {
        if (instance.isInternal) {
            // no public disclosure for internal instance
            return "";
        }

        return localize({
            key: "ReportProblem.publicDisclosureProblem.Text",
            comment: ["Text letting the user know that what they submit will be publicly available. The {0} will be replaced with a link that reads Developer Community"]
        },
            "Your user name, title, and description—including the files and images which are embedded in the description—will be public on {0}.", name);
    }

    public static publicDisclosureComment(name: string) {
        if (instance.isInternal) {
            // no public disclosure for internal instance
            return "";
        }

        return localize({
            key: "ReportProblem.publicDisclosureComment.Text",
            comment: ["Text letting the user know that what they submit will be publicly available. The {0} will be replaced with a link that reads Developer Community"]
        },
            "Your user name, and comment will be public on {0}.", name);
    }

    public static publicFeedbackSite() {
        return localize({
            key: "ReportProblem.publicFeedbackSite.Text",
            comment: ["Text referring to feedback website"]
        },
            "Developer Community");
    }

    public static privateDisclosureAttachments() {
        return localize({
            key: "ReportProblem.publicDisclosureAttachments.Text",
            comment: ["Text letting the user know that what they submit will be private to Microsoft only"]
        },
            "Your attachments—including screenshots, recordings, and system logs—will be private to Microsoft.");
    }

    public static privacyDisclosure(name: string) {
        return localize({
            key: "ReportProblem.privacyDisclosure.Text",
            comment: ["Text letting the user know that their privacy is important for Microsoft. The {0} will be replaced with a link that reads Microsoft Privacy Statement"]
        },
            "For more on privacy, see the {0}.", name);
    }

    public static msftSupportDisclosure(name: string) {
        if (instance.isInternal) {
            // no public disclosure for internal instance
            return "";
        }
        return localize({
            key: "ReportProblem.privacyDisclosure.Text",
            comment: ["Text letting the user know that if they need assistanc they should contact MSFT support"]
        },
            "All information provided by you is for feedback purposes. Should you need help or support from Microsoft, please go to {0}. ", name);
    }

    public static msftSupportStatement() {
        if (instance.isInternal) {
            // no public disclosure for internal instance
            return "";
        }
        return localize({
            key: "ReportProblem.msftSupportStatement.Text",
            comment: ["Text to direct to the Microsoft Support"]
        },
            "Microsoft Support" );
    }

    public static msftPrivacyStatement() {
        if (instance.isInternal) {
            // no public disclosure for internal instance
            return localize({
                key: "ReportProblem.msftGlobalPrivacyStatement.Text",
                comment: ["Text to direct to the Microsoft Privacy Statement for employee, external staff, and candidates"]
            },
                "Microsoft Global Data Privacy Notice for Employees, External Staff and Candidates");
        }
        return localize({
            key: "ReportProblem.msftPrivacyStatement.Text",
            comment: ["Text to direct to the Microsoft Privacy Statement"]
        },
            "Microsoft Privacy Statement");
    }

    public static dataWeCollect() {
        return localize({
            key: "ReportProblem.dataWeCollect.Text",
            comment: ["Text to direct to website explaining data we collect "]
        },
            "Data we collect");
    }

    public static recordTip() {
        return localize({
            key: "ReportProblem.recordTip.Text",
            comment: ["A tip that recording will help investigating the problem"]
        },
            "You may be experiencing a crash, hang, or slowness. Recording steps will help us investigate your problem. Click Record below and follow the instructions");
    }

    public static keywordCpu() {
        return localize({
            key: "ReportProblem.keyword.CPU",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "cpu");
    }

    public static keywordCrash() {
        return localize({
            key: "ReportProblem.keyword.crash",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "crash");
    }

    public static keywordHang() {
        return localize({
            key: "ReportProblem.keyword.hang",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "hang");
    }

    public static keywordStuck() {
        return localize({
            key: "ReportProblem.keyword.stuck",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "stuck");
    }

    public static keywordNotResponding() {
        return localize({
            key: "ReportProblem.keyword.notresponding",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "not responding");
    }
    public static keywordFreeze() {
        return localize({
            key: "ReportProblem.keyword.freeze",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "freeze");
    }

    public static keywordFrozen() {
        return localize({
            key: "ReportProblem.keyword.frozen",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "frozen");
    }

    public static keywordPerformance() {
        return localize({
            key: "ReportProblem.keyword.performance",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "performance");
    }

    public static keywordSlow() {
        return localize({
            key: "ReportProblem.keyword.slow",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "slow");
    }
    public static keywordRAM() {
        return localize({
            key: "ReportProblem.keyword.ram",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "ram");
    }
    public static keywordMemory() {
        return localize({
            key: "ReportProblem.keyword.memory",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "memory");
    }
    public static keywordDeadlock() {
        return localize({
            key: "ReportProblem.keyword.deadlock",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "deadlock");
    }
    public static keywordLag() {
        return localize({
            key: "ReportProblem.keyword.lag",
            comment: ["All lowercase: Key word to look for in text and prompt user for more info"]
        },
            "lag");
    }

    public static includeScreenshotProblem() {
        return localize({
            key: "ReportProblem.includeScreenshotProblem.Text",
            comment: ["Text letting the user know that they can include or not screenshot"]
        },
            "Include a screenshot");
    }

    public static includeScreenshotTitle() {
        return localize({
            key: "ReportProblem.includeScreenshotTitle.Text",
            comment: ["Text letting the user know that they can include or not screenshot"]
        },
            "Include Visual Studio screenshot");
    }

    public static includeScreenshotCantGetScreenshot() {
        return localize({
            key: "ReportProblem.includeScreenshotCantGetScreenshot.Text",
            comment: ["Text letting the user know that there was an error in getting the screenshot"]
        },
            "An unexpected error occurred while obtaining screenshot");
    }

    public static previous() {
        return localize({
            key: "ReportProblem.previous.Text",
            comment: ["Text to show on the Previous button"]
        },
            "Previous");
    }

    public static next() {
        return localize({
            key: "ReportProblem.next.Text",
            comment: ["Text to show on the Next button"]
        },
            "Next");
    }

    public static close() {
        return localize({
            key: "ReportProblem.close.Text",
            comment: ["Text to show on the Close button"]
        },
            "Close");
    }

    public static ok() {
        return localize({
            key: "ReportProblem.OK.Text",
            comment: ["Text to show on the OK button"]
        },
            "OK");
    }

    public static retry() {
        return localize({
            key: "ReportProblem.retry.Text",
            comment: ["Text to show on the Retry button"]
        },
            "Retry");
    }

    public static submit() {
        return localize({
            key: "ReportProblem.submit.Text",
            comment: ["Text to show on the Submit button"]
        },
            "Submit");
    }

    public static justVote() {
        return localize({
            key: "ReportProblem.justVote.Text",
            comment: ["Text to show on the Just Vote button"]
        },
            "Just Vote");
    }

    public static voteWithMoreInfo() {
        return localize({
            key: "ReportProblem.voteAndMoreInfo.Text",
            comment: ["Text to show on the Vote with more info button"]
        },
            "Vote and give more info");
    }

    public static accept() {
        return localize({
            key: "ReportProblem.AcceptButton.Text",
            comment: ["Text to show on the Accept button"]
        },
            "Accept");
    }

    public static accepted() {
        return localize({
            key: "ReportProblem.AcceptButton.Status",
            comment: ["Text to read when accepted"]
        },
            "Accepted");
    }

    public static cancel() {
        return localize({
            key: "ReportProblem.CancelButton.Text",
            comment: ["Text to show on the Cancel button"]
        },
            "Cancel");
    }

    public static cancelled() {
        return localize({
            key: "ReportProblem.CancelButton.Status",
            comment: ["Text to read when cancelled"]
        },
            "Cancelled");
    }

    public static cropScreenshot() {
        return localize({
            key: "ReportProblem.CropScreenshotButton.Text",
            comment: ["Text to show on the Crop screenshot button"]
        },
            "Crop screenshot");
    }

    public static cropPrompt() {
        return localize({
            key: "ReportProblem.CropInfo.Text",
            comment: ["Text explaining how to crop screenshot"]
        },
            "Press Tab to switch crop corners");
    }

    public static cropHandleTopLeft() {
        return localize({
            key: "ReportProblem.CropInfo.cropHandleTopLeft",
            comment: ["Text explaining how to use top-left crop image handle"]
        },
            "Top-left crop corner. Press Tab and Shift-Tab to switch crop corners");
    }

    public static cropHandleBottomRight() {
        return localize({
            key: "ReportProblem.CropInfo.cropHandleBottomRight",
            comment: ["Text explaining how to use bottom-right crop image handle"]
        },
            "Bottom-right crop corner");
    }

    public static cropInfoLeft(percent: number) {
        return localize({
            key: "ReportProblem.CropInfo.cropInfoLeft",
            comment: ["Text explaining location of crop handle as percent of total image. Read by screen reader"]
        },
            "left {0} percent", percent);
    }

    public static cropInfoTop(percent: number) {
        return localize({
            key: "ReportProblem.CropInfo.cropInfoTop",
            comment: ["Text explaining location of crop handle as percent of total image. Read by screen reader"]
        },
            "top {0} percent", percent);
    }

    public static cropInfoWidth(percent: number) {
        return localize({
            key: "ReportProblem.CropInfo.cropInfoWidth",
            comment: ["Text explaining size of crop region as percent of total image. Read by screen reader"]
        },
            "width {0} percent", percent);
    }

    public static cropInfoHeight(percent: number) {
        return localize({
            key: "ReportProblem.CropInfo.cropInfoHeight",
            comment: ["Text explaining size of crop region as percent of total image. Read by screen reader"]
        },
            "height {0} percent", percent);
    }

    public static previewScreenshotTitle() {
        return localize({
            key: "ReportProblem.previewScreenshotTitle.Text",
            comment: ["Text to show above the screenshot preview"]
        },
            "Preview");
    }

    public static attachmentsTitle() {
        return localize({
            key: "ReportProblem.attachmentsTitle.Text",
            comment: ["Text to show above the attachments list"]
        },
            "Attachments");
    }

    public static attachedByUser() {
        return localize({
            key: "ReportProblem.attachedByUser.Text",
            comment: ["Text to tell that selected file was attached by user"]
        },
            "Attached by user");
    }

    public static additionalAttachmentsTitle() {
        return localize({
            key: "ReportProblem.additionalAttachmentsTitle.Text",
            comment: ["Text to show above the additional attachments list"]
        },
            "Additional attachments");
    }

    public static systemLogs(systemLogsCount: number) {
        return localize({
            key: "ReportProblem.systemLogs.Text",
            comment: ["Label and count to show above additional attachments list for system logs"]
        },
            "System logs {0}", systemLogsCount);
    }

    public static otherFiles(filesCount: number) {
        return localize({
            key: "ReportProblem.otherFiles.Text",
            comment: ["Label and count to show above additional attachments list for other files"]
        },
            "Other files {0}", filesCount);
    }

    public static attachExtraFiles() {
        return localize({
            key: "ReportProblem.attachExtraFiles.Text",
            comment: ["Text to show on the Attach Additional Files button"]
        },
            "Attach Additional Files");
    }

    public static additionalFiles() {
        return localize({
            key: "ReportProblem.additionalFiles.Text",
            comment: ["Text to show above list of additional files attached"]
        },
            "Additional Files");
    }

    public static attachMoreFiles() {
        return localize({
            key: "ReportProblem.attachMoreFiles.Text",
            comment: ["Text to show on the Attach more files button"]
        },
            "Attach more files");
    }

    public static delete(fileName: string) {
        return localize({
            key: "ReportProblem.delete.Text",
            comment: ["Text to show on hover over delete button"]
        },
            "Remove '{0}'", fileName);
    }

    public static screenshotAttachments() {
        return localize({
            key: "ReportProblem.screenshotAttachments.Text",
            comment: ["Title of the attachments list"]
        },
            "Screenshot/attachments");
    }

    public static systemLogsTitle() {
        return localize({
            key: "ReportProblem.systemLogs.Title",
            comment: ["Title of the system logs list"]
        },
            "Attach system logs");
    }

    public static systemLogsExplanationSummary() {
        return localize({
            key: "ReportProblem.systemLogs.explanationSummary",
            comment: ["Title of the system logs list"]
        },
            "Below is a recommended list of system logs to include with your report. You can open and view the contents of any system logs before submitting the report.");
    }

    public static systemLogsNone() {
        return localize({
            key: "ReportProblem.systemLogs.Text",
            comment: ["Text to show that there are no system logs being sent"]
        },
            "None");
    }

    public static screenshot() {
        return localize({
            key: "ReportProblem.Screenshot.Text",
            comment: ["Text to show there is a screenshot included in the attachments"]
        },
            "Screenshot");
    }

    public static noScreenshot() {
        return localize({
            key: "ReportProblem.NoScreenshot.Text",
            comment: ["Text to show there isn't a screenshot included in the attachments"]
        },
            "No screenshot");
    }

    public static sendingReportPleaseWait() {
        return localize({
            key: "ReportProblem.PleaseWait.Text",
            comment: ["Text to let the user know to wait while we send the problem"]
        },
            "Sending your report, please wait...");
    }

    public static thanks() {
        return localize({
            key: "ReportProblem.Thanks.Text",
            comment: ["Text to let the user know that we sent"]
        },
            "Thanks!");
    }

    public static thanksPrivateBuild() {
        return localize({
            key: "ReportProblem.ThanksPrivateBuild.Text",
            comment: ["Text to let the user know that we sent when the build is private (NDA)"]
        },
            "We've received your problem report. We will follow up if we have any questions.");
    }

    public static thanksReceivedFeedback() {
        return localize({
            key: "ReportProblem.thanksReceivedFeedback.Text",
            comment: ["Explanation text"]
        },
            "We’ve received your feedback which helps us make Visual Studio a better product for everyone. You'll shortly receive a confirmation email with a link to it.");
    }

    public static thanksReceivedFeedbackSendEmail(user: string) {
        return localize({
            key: "ReportProblem.thanksReceivedFeedbackSendEmail.Text",
            comment: ["Explanation text"]
        },
            "Thank you, {0}. We've received your feedback. Any attached files will not be shared publicly. We’re sending you an email with a link to the feedback ticket shortly.",
            user);
    }

    public static thanksUser(user: string) {
        return localize({
            key: "ReportProblem.thanksUser.Text",
            comment: ["Explanation text"]
        },
            "Thank you, {0}", user);
    }

    public static learnAboutFeedbackProcess() {
        return localize({
            key: "ReportProblem.thanksWhatsNext.learnAboutFeedbackProcess",
            comment: ["Text to take user to document about feedback process"]
        },
            "Learn more about the feedback process");
    }

    public static thanksWhatsNext() {
        return localize({
            key: "ReportProblem.thanksWhatsNext.Text",
            comment: ["Explanation text"]
        },
            "What happens next?");
    }

    public static thanksWhatsNext_EngineerWillReview() {
        return localize({
            key: "ReportProblem.thanksWhatsNext_EngineerWillReview.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "The engineering area owner for the feedback will review it");
    }

    public static thanksWhatsNext_PrioritizeActions() {
        return localize({
            key: "ReportProblem.thanksWhatsNext_PrioritizeActions.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "Prioritize actions for it and respond with updates");
    }

    public static thanksWhatsNext_ReceiveEmail() {
        return localize({
            key: "ReportProblem.thanksWhatsNext_ReceiveEmail.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "You will receive email with status updates or new comments.");
    }

    public static thanks_BrowseAllFeedback() {
        return localize({
            key: "ReportProblem.thanks_BrowseAllFeedback.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "Browse all feedback");
    }

    public static thanks_SeeYourComment() {
        return localize({
            key: "ReportProblem.thanks_SeeYourComment.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "Now you can see your comment under the existing problem. You will receive notifications about comments and solutions. The issue will appear in you items.");
    }

    public static thanks_viewDiscussion() {
        return localize({
            key: "ReportProblem.thanks_viewDiscussion.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "See your comment");
    }

    public static thanks_ReportAnotherProblem() {
        return localize({
            key: "ReportProblem.thanks_ReportAnotherProblem.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "Report another problem");
    }

    public static thanks_ShowMyActivity() {
        return localize({
            key: "ReportProblem.thanks_ShowMyActivity.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "Show my activity");
    }

    public static thanksWhatsNext_Upvote() {
        return localize({
            key: "ReportProblem.thanksWhatsNext_Upvote.Text",
            comment: ["Explanation text"]
        },
            "Now that we have your feedback, others can upvote and share their own comments. Your report and community input, together, are valuable to us in understanding customer impact.");
    }

    public static thanksWhatsNext_EngineerWillLook() {
        return localize({
            key: "ReportProblem.thanksWhatsNext_EngineerWillLook.Text",
            comment: ["Explanation text, please keep the <a ..> and </a> link parts"]
        },
            "The engineering area owner for the feedback will review it, <a href=\"https://go.microsoft.com/fwlink/?linkid=2090214\">prioritize action</a> based on broad customer impact and respond with an update.");
    }

    public static thanksWhatsNext_YouWillGetEmail() {
        return localize({
            key: "ReportProblem.thanksWhatsNext_YouWillGetEmail.Text",
            comment: ["Explanation text"]
        },
            "You will receive email notification when there are status updates or new comments.");
    }
    public static thanksGotVote() {
        return localize({
            key: "ReportProblem.thanksGotVote.Text",
            comment: ["Explanation text"]
        },
            "We’ve received your vote.");
    }
    public static thanksWhatsNext_YouWillGetEmail_ForVote() {
        return localize({
            key: "ReportProblem.thanksWhatsNext_YouWillGetEmail_ForVote.Text",
            comment: ["Explanation text"]
        },
            "We'll email you for changes like new comments and status update.");
    }
    public static thanksGotNMI() {
        return localize({
            key: "ReportProblem.thanksGotNMI.Text",
            comment: ["Explanation text"]
        },
            "We’ve received the information you sent.");
    }
    public static thanksOwnerWillReviewNMI() {
        return localize({
            key: "ReportProblem.thanksOwnerWillReviewNMI.Text",
            comment: ["Explanation text"]
        },
            "The appropriate engineering area owner will review it in depth, and respond with an update.");
    }
    public static thanksAttachmentsAndPrivacy() {
        return localize({
            key: "ReportProblem.thanksAttachmentsAndPrivacy.Text",
            comment: ["Explanation text"]
        },
            "Attachments & Privacy");
    }
    public static thanksAttachmentsAndPrivacy_Explanation() {
        return localize({
            key: "ReportProblem.thanksAttachmentsAndPrivacy_Explanation.Text",
            comment: ["Explanation text"]
        },
            "If you included attachments, those are being uploaded in the background so you can continue using feedback. For your privacy, attachments are not posted publicly but they are available to Microsoft.");
    }
    public static thanksThanksAgain() {
        return localize({
            key: "ReportProblem.thanksThanksAgain.Text",
            comment: ["Explanation text"]
        },
            "We thank you very much for being a contributor to Visual Studio Developer Community.");
    }
    public static thanksVSTeam() {
        return localize({
            key: "ReportProblem.thanksVSTeam.Text",
            comment: ["Explanation text"]
        },
            "Visual Studio Team");
    }

    public static reproStepsTemplate() {
        return localize({
            key: "ReportProblem.reproStepsTemplate.Text",
            comment: ["Text template for user to add to. Please preserve new lines."]
        },
            `What steps will reproduce the problem?
1.
2.
3.

What is the expected output? What do you see instead?


Please provide any additional information below.
`);
    }

    public static emailIsOnTheWay() {
        return localize({
            key: "ReportProblem.EmailIsOnTheWay.Text",
            comment: ["Text to let the user know that they will receive email, and the email will have more text"]
        },
            "A confirmation email with more information is on the way.");
    }

    public static errorOnSend() {
        return localize({
            key: "ReportProblem.ErrorOnSend.Text",
            comment: ["Text to let the user know that we couldn't send"]
        },
            "Sorry, we couldn't send your report, because the server connection timed out. Please retry now or sign out from Visual Studio, sign in using Visual Studio and try again");
    }

    public static votePleaseWait() {
        return localize({
            key: "ReportProblem.VotePleaseWait.Text",
            comment: ["Text to let the user know to wait while we send the vote"]
        },
            "Sending your vote, please wait...");
    }

    public static voteThanksSubtitle() {
        return localize({
            key: "ReportProblem.voteThanksSubtitle.Text",
            comment: ["Text to let the user know that we received their enhanced vote and that it will help us"]
        },
            "More details means we can investigate faster.");
    }

    public static voteThanksPrivateBuild() {
        return localize({
            key: "ReportProblem.VoteThanksPrivateBuild.Text",
            comment: ["Text to let the user know that we sent when the build is private (NDA)"]
        },
            "We've received your vote. We will follow up if we have any questions.");
    }

    public static voteErrorOnSend() {
        return localize({
            key: "ReportProblem.VoteErrorOnSend.Text",
            comment: ["Text to let the user know that we couldn't send"]
        },
            "Sorry, we couldn't send your vote. Please retry now or sign out, sign in, and try again");
    }

    public static selectFileError(errorMessage: string) {
        return localize({
            key: "ReportProblem.selectFileError.Text",
            comment: ["Text to let the user know that there was an error during file selection process"]
        },
            "Sorry, we ran into an error: '{0}'",
            errorMessage);
    }

    public static viewFileError(errorMessage: string) {
        return localize({
            key: "ReportProblem.viewFileError.Text",
            comment: ["Text to let the user know that we couldn't open file"]
        },
            "Sorry, we couldn't open that file: '{0}'",
            errorMessage);
    }

    public static startRecordingError(errorMessage: string) {
        return localize({
            key: "ReportProblem.startRecordingError.Text",
            comment: ["Text to let the user know that we couldn't start recording"]
        },
            "Sorry, we couldn't start the recording: '{0}'",
            errorMessage);
    }

    public static errorInfo(errorMessage: string) {
        return localize({
            key: "ReportProblem.errorMessage.Text",
            comment: ["Information about error message"]
        },
            "Error message: '{0}'",
            errorMessage);
    }

    public static unexpectedError() {
        return localize({
            key: "ReportProblem.unExpectedError.Text",
            comment: ["Unexpected error"]
        },
            "Unexpected error");
    }

    public static error() {
        return localize({
            key: "ReportProblem.Error.Text",
            comment: ["title for general purpose error dialog"]
        },
            "Error");
    }

    public static stillCantReport() {
        return localize({
            key: "ReportProblem.stillCantReport.Text",
            comment: ["Text asking the user if they were able to report an issue"]
        },
            "Still can’t report your issue?");
    }

    public static sendErrorLetUsKnow() {
        return localize({
            key: "ReportProblem.sendErrorLetUsKnow.Text",
            comment: ["Hyperlink asking the user to send us a message"]
        },
            "Let us know");
    }

    public static commentTab() {
        return localize({
            key: "ReportProblem.commentTab.Text",
            comment: ["Comment tab in first transition step in the EnhanceYourVote dialog"]
        },
            "Comment");
    }

    public static screenshotTab() {
        return localize({
            key: "ReportProblem.screenshotTab.Text",
            comment: ["Screenshot tab in Second transition step in the ReportAProblem/EnhanceYourVote dialog"]
        },
            "Screenshot");
    }

    public static recordTab() {
        return localize({
            key: "ReportProblem.recordTab.Text",
            comment: ["Record tab in Second transition step in the ReportAProblem/EnhanceYourVote dialog"]
        },
            "Record");
    }

    public static recordTitle() {
        return localize({
            key: "ReportProblem.recordTitle.Text",
            comment: ["Text to show above the record processes list"]
        },
            "Record your actions");
    }

    public static vsInstanceHeader() {
        return localize({
            key: "ReportProblem.vsInstanceTable.FirstHeader",
            comment: ["Header for the VS Instances table in the Record tab in ReportAProblem"]
        },
            "Visual Studio Instance (window title) and Process ID");
    }

    public static pidHeader() {
        return localize({
            key: "ReportProblem.vsInstanceTable.PIDHeader",
            comment: ["Header for the VS Instances table in the Record tab in ReportAProblem"]
        },
            "Process ID");
    }

    public static currentVSInstance() {
        return localize({
            key: "ReportProblem.vsInstanceTable.current",
            comment: ["Text to show that this is the parent VSInstance"]
        },
            "Visual Studio (Original Instance)");
    }

    public static newVSInstance() {
        return localize({
            key: "ReportProblem.vsInstanceTable.newVSInstance",
            comment: ["Text to show to create a new VSInstance"]
        },
            "Create new Visual Studio instance");
    }

    public static newVSInstanceError(errorMessage: string) {
        return localize({
            key: "ReportProblem.vsInstanceTable.newVSInstance.error",
            comment: ["Text to show when there is error in creating a new VSInstance"]
        },
            "Error creating new instance of Visual Studio: {0}", errorMessage);
    }

    public static vsInstancesFetchError(errorMessage: string) {
        return localize({
            key: "ReportProblem.vsInstanceTable.vsInstancesFetchError.error",
            comment: ["Text to show when there is error in fetching list of VS instances"]
        },
            "Error fetching list of Visual Studio instances: {0}", errorMessage);
    }

    public static recordYourActions() {
        return localize({
            key: "ReportProblem.RecordYourActions.Text",
            comment: ["Text showing up above the Record button before recording for the first time"]
        },
            "Record your actions to reproduce the issue.");
    }

    public static startRecord() {
        return localize({
            key: "ReportProblem.StartRecord.Text",
            comment: ["Text showing up on Record button before recording for the first time"]
        },
            "Start recording");
    }

    public static generatedByRecorder() {
        return localize({
            key: "ReportProblem.generatedByRecorder.Text",
            comment: ["Text to tell that selected file was created by action recorder"]
        },
            "Generated by action recorder");
    }

    public static generatedByRecorderRemotely() {
        return localize({
            key: "ReportProblem.generatedByRecorderRemotely.Text",
            comment: ["Text to tell that selected file was created by action recorder on remote machine"]
        },
            "Generated by action recorder on remote machine");
    }

    public static recording() {
        return localize({
            key: "ReportProblem.Recording.Text",
            comment: ["Text showing up while the user records steps"]
        },
            "Please record your steps... ");
    }

    public static dontWait() {
        return localize({
            key: "ReportProblem.DontWait.Text",
            comment: ["Text showing up while the user waits for processing to happen on the collected diagnostics telling them they don't have to wait to submit feedback"]
        },
            "You don't have to wait!");
    }

    public static pleaseWait() {
        return localize({
            key: "ReportProblem.PleaseWait.Text",
            comment: ["Text showing up while the user waits for processing to happen on the collected diagnostics telling them to wait to submit feedback"]
        },
            "Please wait!");
    }

    public static processing() {
        return localize({
            key: "ReportProblem.Processing.Text",
            comment: ["Text showing up while the user waits for processing to happen on the collected diagnostics"]
        },
            "We are processing your recording. You will be able to submit the report after processing is done.");
    }

    public static processingButCanSubmit() {
        return localize({
            key: "ReportProblem.Processing.Text",
            comment: ["Text showing up while the user waits for processing to happen on the collected diagnostics"]
        },
            "We are still processing your recording. But it is safe to submit the report and close Visual Studio now.");
    }

    public static processingFile() {
        return localize({
            key: "ReportProblem.ProcessingFile.Text",
            comment: ["Text showing up when user tries to view file which is being processed"]
        },
            "Please wait while we finish processing this file. This may take a few minutes.");
    }

    public static recordfailure() {
        return localize({
            key: "ReportProblem.Recordfailure.Text",
            comment: ["Text showing up letting the user know that collecting failed"]
        },
            "Collection hasn't recorded anything. Please try again!");
    }

    public static searchAnything() {
        return localize({
            key: "Search.searchAnything.Text",
            comment: ["Text to let the user know that they can search"]
        },
            "Search for anything");
    }

    public static writeComment() {
        return localize({
            key: "Search.WriteComment.Text",
            comment: ["Placeholder text for commenting"]
        },
            "Write a comment");
    }

    public static addingComment() {
        return localize({
            key: "Search.AdddingComment.Text",
            comment: ["Progress text when adding a comment"]
        },
            "Adding comment...");
    }
    public static failedAddingComment() {
        return localize({
            key: "Search.failedAddingComment.Text",
            comment: ["Placeholder text for commenting"]
        },
            "Failed adding comment. Please sign out, sign in, and try again.");
    }

    public static chooseFiles() {
        return localize({
            key: "ReportProblem.AttachFiles.Title",
            comment: ["Shown in the title of the file picker for attaching files"]
        },
            "Choose Files");
    }

    public static signInPrompt() {
        return localize({
            key: "SignIn.SignIn.Text",
            comment: ["Text to let the user know that they need to sign in"]
        },
            "Sign in to get the most out of the feedback experience");
    }

    public static signInCheck() {
        return localize({
            key: "SignIn.SignInCheck.Text",
            comment: ["Text that appears the first time a customer opens the app"]
        },
            "Authenticating...");
    }

    public static authenticated() {
        return localize({
            key: "SignIn.authenticated.Text",
            comment: ["Text to read after user is authenticated"]
        },
            "Successfully authenticated");
    }

    public static signInExecuting() {
        return localize({
            key: "SignIn.SignInExecuting.Text",
            comment: ["Text showing sign in is in progress"]
        },
            "Signing in...");
    }

    public static signInSuccess() {
        return localize({
            key: "SignIn.SignInSuccess.Text",
            comment: ["Text showing sign in succeeded"]
        },
            "Signed in");
    }

    public static signInError(errorMessage: string) {
        return localize({
            key: "SignIn.SignInError.Text",
            comment: ["Text showing there's an error during sign in and error message"]
        },
            "Error signing in: '{0}'", errorMessage);
    }

    public static signInExpired() {
        return localize({
            key: "SignIn.SignInExpired.Text",
            comment: ["Text showing when customer's credentials have expired"]
        },
            "Your sign-in info has expired. Please sign in again.");
    }

    public static reenterYourCredentials() {
        return localize({
            key: "SignIn.reenterYourCredentials.Text",
            comment: ["Link asking customer to re-enter sign in credentials"]
        },
            "Re-enter your credentials");
    }

    public static signInWithMicrosoftAccount() {
        return localize({
            key: "SignIn.signInWithMicrosoftAccount.Text",
            comment: ["Text showing for internal customers that didn't sign in with their @microsoft account"]
        },
            "You are a Microsoft Internal customer. Please sign in with your @microsoft.com account.");
    }

    public static disconnected() {
        return localize({
            key: "General.disconnected.Text",
            comment: ["Title showing up on main UI if the browser got disconnected from VS"]
        },
            "Disconnected");
    }

    public static disconnectedFromVS() {
        return localize({
            key: "General.disconnectedFromVS.Text",
            comment: ["Text showing up on main UI if the browser got disconnected from VS"]
        },
            "Disconnected from Visual Studio. Please close this window and reopen from a running instance of Visual Studio");
    }

    public static errorDueToAnotherOpenTab() {
        return localize({
            key: "General.errorDueToAnotherOpenTab.Text",
            comment: ["Text showing up on main UI if the browser tab can't connect to VS because another tab is already connected successfully."]
        },
            "You have another tab which is connected to Visual Studio. Please close this one and use that other tab.");
    }

    public static signIn() {
        return localize({
            key: "SignIn.SignIn.ButtonText",
            comment: ["Button text for sign in button"]
        },
            "Sign In");
    }

    public static signOut() {
        return localize({
            key: "SignIn.SignOut.ButtonText",
            comment: ["Button text for sign out button"]
        },
            "Sign Out");
    }

    public static viewingPageUsingAccount(emailId: string) {
        return localize({
            key: "SignIn.viewingPageUsingAccount.Text",
            comment: ["Text indicating the email account being used for current page"]
        },
            "Viewing as {0}", emailId);
    }

    public static authNeeded_ReportProblem() {
        return localize({
            key: "AuthNeeded.ReportProblem.Text",
            comment: ["Text explaining the need to sign in"]
        },
            "Please sign in to report a new problem");
    }

    public static authNeeded_SuggestFeature() {
        return localize({
            key: "AuthNeeded.SuggestFeature.Text",
            comment: ["Text explaining the need to sign in"]
        },
            "Please sign in to suggest a feature");
    }

    public static authNeeded_Vote() {
        return localize({
            key: "AuthNeeded.Vote.Text",
            comment: ["Text explaining the need to sign in"]
        },
            "Please sign in to vote.");
    }

    public static authNeeded() {
        return localize({
            key: "AuthNeeded.General.Text",
            comment: ["Text explaining the need to sign in"]
        },
            "Please sign in to continue");
    }

    public static authNeeded_AddComment() {
        return localize({
            key: "AuthNeeded.AddComment.Text",
            comment: ["Text explaining the need to sign in"]
        },
            "Sign in to write a comment");
    }

    public static cantVote() {
        return localize({
            key: "Cant.Vote.Text",
            comment: ["Text explaining that voting is disabled"]
        },
            "Voting is not available because this issue is closed");
    }

    public static alreadyVoted() {
        return localize({
            key: "Already.Voted.Text",
            comment: ["Text explaining that the customer voted already for a feedback"]
        },
            "You have already voted on this feedback");
    }

    public static youCreatedIt() {
        return localize({
            key: "Already.Created.Text",
            comment: ["Text explaining that the customer submitted the issue and can't vote on it"]
        },
            "Voting is not available because you reported this feedback");
    }

    public static failedVoting() {
        return localize({
            key: "Failed.Voting.Text",
            comment: ["Message shown to the customer when voting failed"]
        },
            "We couldn't process your vote. Please sign out, sign in, and try again.");
    }

    public static commentUpvoteAnswer() {
        return localize({
            key: "General.commentUpvoteAnswer.Text",
            comment: ["Text on link where you can comment, upvote, add solution"]
        },
            "Add Solution");
    }

    public static comments() {
        return localize({
            key: "General.comments.Text",
            comment: ["Title for the list of comments"]
        },
            "Comments");
    }

    public static answersTitle(answerCount: number) {
        return localize({
            key: "General.Answers.Text",
            comment: ["Title for the list of solutions. 0 - solution count"]
        },
            "{0} Solutions", answerCount);
    }

    public static incorrectLink(url: string) {
        return localize({
            key: "General.IncorrectLink.Text",
            comment: ["Text explaining a link is not properly formed. 0 - solution count"]
        },
            "Could not open link '{0}'", url);
    }

    public static problemsThatMightBeSimilar() {
        return localize({
            key: "General.ProblemsSuggestInfo.Text",
            comment: ["Text explaining that the list of suggested problems following it might be similar to the one we're searching for"]
        },
            "Related Problems:");
    }

    public static featuresThatMightBeSimilar() {
        return localize({
            key: "General.FeaturesSuggestInfo.Text",
            comment: ["Text explaining that the list of suggested features following it might be similar to the one we're searching for"]
        },
            "Related Features:");
    }

    public static vote() {
        return localize({
            key: "General.Vote.Text",
            comment: ["Text showing up on main UI to show that you can vote"]
        },
            "Vote");
    }

    public static reportedBy(createdByName: string, onFriendlyDate: string) {
        return localize({
            key: "General.ReportedBy.Text",
            comment: ["Shows up in problem detail info, 0 - person name, 1 - date"]
        },
            "{0} reported {1}", createdByName, onFriendlyDate);
    }

    public static commentBy(commentByName: string, onFriendlyDate: string) {
        return localize({
            key: "General.CommentBy.Text",
            comment: ["Shows up above comments to represent author of comment and date, 0 - person name, 1 - date"]
        },
            "{0} on {1}", commentByName, onFriendlyDate);
    }

    public static answerCreatedBy(createdByName: string) {
        return localize({
            key: "Answers.CreatedBy.Text",
            comment: ["Shows up in lighter text for each solution, 0 - person name"]
        },
            "Solution by {0}", createdByName);
    }

    public static lastUpdatedBy(updatedByName: string, onFriendlyDate: string) {
        return localize({
            key: "General.UpdatedBy.Text",
            comment: ["Shows up for each search result, 0 - person name, 1 - date"]
        },
            "{0} updated {1}", updatedByName, onFriendlyDate);
    }

    public static errorLoadingAnswers() {
        return localize({
            key: "General.ErrorLoadingAnswers.Text",
            comment: ["Text to let the user know that we failed to load solutions"]
        },
            "Error loading solutions");
    }

    public static stateFixed() {
        return localize({
            key: "Problem.State.Fixed",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Fixed");
    }

    public static stateDuplicate() {
        return localize({
            key: "Problem.State.Duplicate",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Duplicate");
    }

    public static stateWontFix() {
        return localize({
            key: "Problem.State.WontFix",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Won't Fix");
    }

    public static stateWillNotFix() {
        return localize({
            key: "Problem.State.WillNotFix",
            comment: ["A name of a state a problem can be in"]
        },
            "Will Not Fix");
    }

    public static stateMoreInfo() {
        return localize({
            key: "Problem.State.MoreInfo",
            comment: ["A name of a state a problem can be in"]
        },
            "Need More Info");
    }

    public static stateTriaged() {
        return localize({
            key: "Problem.State.Triaged",
            comment: ["A name of a state a problem can be in"]
        },
            "Triaged");
    }

    public static stateNew() {
        return localize({
            key: "Problem.State.New",
            comment: ["A name of a state a problem can be in"]
        },
            "New");
    }

    public static stateInvestigating() {
        return localize({
            key: "Problem.State.Investigating",
            comment: ["A name of a state a problem can be in"]
        },
            "Under Investigation");
    }

    public static stateAccepted() {
        return localize({
            key: "Problem.State.Accepted",
            comment: ["A name of a state a problem can be in"]
        },
            "Triaged");
    }

    public static statePendingRelease() {
        return localize({
            key: "Problem.State.PendingRelease",
            comment: ["A name of a state a problem can be in"]
        },
            "Fixed - Pending Release");
    }

    public static stateNotBug() {
        return localize({
            key: "Problem.State.NotBug",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Not a Bug");
    }

    public static stateNotEnoughInfo() {
        return localize({
            key: "Problem.State.NoInfo",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Not Enough Info");
    }

    public static stateFuture() {
        return localize({
            key: "Problem.State.Future",
            comment: ["A name of a state a problem can be in"]
        },
            "Future");
    }

    public static stateClosedFuture() {
        return localize({
            key: "Problem.State.ClosedFuture",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Future");
    }

    public static stateClosedLowPri() {
        return localize({
            key: "Problem.State.ClosedLowPri",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Lower Priority");
    }

    public static stateClosedOtherProduct() {
        return localize({
            key: "Problem.State.ClosedOtherProduct",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Other Product");
    }

    public static stateInfoGiven() {
        return localize({
            key: "Problem.State.InfoGiven",
            comment: ["A name of a state a problem can be in"]
        },
            "Info Given");
    }

    public static statePendingReleaseShort() {
        return localize({
            key: "Problem.State.PendingReleaseShort",
            comment: ["A name of a state a problem can be in"]
        },
            "Pending Release");
    }

    public static stateFixedInFutureRelease() {
        return localize({
            key: "Problem.State.FixedInFutureRelease",
            comment: ["A name of a state a problem can be in"]
        },
            "Fixed in Future Release");
    }

    public static stateReopen() {
        return localize({
            key: "Problem.State.Reopen",
            comment: ["A name of a state a problem can be in"]
        },
            "Reopen");
    }

    public static stateUnderConsideration() {
        return localize({
            key: "Problem.State.UnderConsideration",
            comment: ["A name of a state a problem can be in"]
        },
            "Under Consideration");
    }

    public static stateClosedSuggestion() {
        return localize({
            key: "Problem.State.ClosedSuggestion",
            comment: ["A name of a state a problem can be in"]
        },
            "Closed - Suggestion");
    }

    public static stateUnknown() {
        return localize({
            key: "Problem.State.Unknown",
            comment: ["A name of a state a problem can be in"]
        },
            "Unknown");
    }

    public static ideaStateClosed() {
        return localize({
            key: "Idea.State.Closed",
            comment: ["A name of a state an idea can be in"]
        },
            "Closed");
    }

    public static ideaStateDuplicate() {
        return localize({
            key: "Idea.State.Duplicate",
            comment: ["A name of a state an idea can be in"]
        },
            "Closed - Duplicate");
    }

    public static ideaStateNotEnoughInfo() {
        return localize({
            key: "Idea.State.NotEnoughInfo",
            comment: ["A name of a state an idea can be in"]
        },
            "Closed - Not Enough Info");
    }

    public static ideaStateOtherProduct() {
        return localize({
            key: "Idea.State.OtherProduct",
            comment: ["A name of a state an idea can be in"]
        },
            "Closed - Other Product");
    }

    public static ideaStateOutOfScope() {
        return localize({
            key: "Idea.State.OutOfScope",
            comment: ["A name of a state an idea can be in"]
        },
            "Closed - Out of Scope");
    }

    public static ideaStatePending() {
        return localize({
            key: "Idea.State.Pending",
            comment: ["A name of a state an idea can be in"]
        },
            "Completed - Preview");
    }

    public static ideaStateFixed() {
        return localize({
            key: "Idea.State.Fixed",
            comment: ["A name of a state an idea can be in"]
        },
            "Completed – Release");
    }

    public static ideaStateMoreInfo() {
        return localize({
            key: "Idea.State.MoreInfo",
            comment: ["A name of a state an idea can be in"]
        },
            "Need More Info");
    }

    public static ideaStateNew() {
        return localize({
            key: "Idea.State.New",
            comment: ["A name of a state an idea can be in"]
        },
            "New");
    }

    public static ideaStateInvestigation() {
        return localize({
            key: "Idea.State.Investigation",
            comment: ["A name of a state an idea can be in"]
        },
            "On Roadmap");
    }

    public static ideaStateConsideration() {
        return localize({
            key: "Idea.State.Consideration",
            comment: ["A name of a state an idea can be in"]
        },
            "Under Review");
    }

    public static userUnknown() {
        return localize({
            key: "Problem.User.Unknown",
            comment: ["Text shown when the user name is not known"]
        },
            "Unknown");
    }

    public static sortActive() {
        return localize({
            key: "Search.SortOption.Active",
            comment: ["A sort option for searching displayed in a drop down below search bar"]
        },
            "Activity");
    }

    public static sortDate() {
        return localize({
            key: "Search.SortOption.Date",
            comment: ["A sort option for searching displayed in a drop down below search bar"]
        },
            "Date");
    }

    public static sortNewest() {
        return localize({
            key: "Search.SortOption.Newest",
            comment: ["A sort option for searching displayed in a drop down below search bar"]
        },
            "Newest");
    }

    public static sortVotes() {
        return localize({
            key: "Search.SortOption.Votes",
            comment: ["A sort option for searching displayed in a drop down below search bar"]
        },
            "Votes");
    }

    public static sortRelevance() {
        return localize({
            key: "Search.SortOption.Relevance",
            comment: ["A sort option for searching displayed in a drop down below search bar"]
        },
            "Relevance");
    }

    public static filterAll() {
        return localize({
            key: "Search.FilterOption.All",
            comment: ["A filter option for searching displayed in a drop down below search bar"]
        },
            "No Filter");
    }

    public static filterUnsolved() {
        return localize({
            key: "Search.FilterOption.Unsolved",
            comment: ["A filter option for searching displayed in a drop down below search bar"]
        },
            "Unsolved");
    }

    public static filterFollow() {
        return localize({
            key: "Search.FilterOption.Follow",
            comment: ["A filter option for searching displayed in a drop down below search bar"]
        },
            "Items I follow");
    }

    public static filterCurrentBuild() {
        return localize({
            key: "Search.FilterOption.CurrentBuild",
            comment: ["A filter option for searching displayed in a drop down below search bar"]
        },
            "My product version");
    }

    public static loadMore() {
        return localize({
            key: "ReportProblem.SearchResults.Button.loadMore",
            comment: ["Load more button for search results"]
        },
            "Load more ...");
    }

    public static showAll() {
        return localize({
            key: "General.list.showAll.text",
            comment: ["Text for button to show all content"]
        },
            "Show all");
    }

    public static showLess() {
        return localize({
            key: "General.list.showLess.text",
            comment: ["Text for button to show less content"]
        },
            "Show less");
    }

    public static iHaveThisProblemToo() {
        return localize({
            key: "CreatePostView.SearchResults.Button.iHaveThisProblemToo",
            comment: ["My issue too button for search results"]
        },
            "This is exactly my problem");
    }

    public static iHaveThisSuggestionToo() {
        return localize({
            key: "CreatePostView.SearchResults.Button.iHaveThisSuggestionToo",
            comment: ["My issue too button for search results"]
        },
            "This is exactly my suggestion");
    }

    public static goBack() {
        return localize({
            key: "Navigation.Link.goBack",
            comment: ["Link to return to previous view"]
        },
            "Go back");
    }

    public static backToSearchResults() {
        return localize({
            key: "Navigation.Link.backToSearchResults",
            comment: ["Link to return to search results view"]
        },
            "Back to search results");
    }

    public static backToHome() {
        return localize({
            key: "Navigation.Link.backToHome",
            comment: ["Link to return to home view"]
        },
            "Back to Home");
    }

    public static developerCommunity() {
        return localize({
            key: "MainView.Title.developerCommunity",
            comment: ["Title text in main screen"]
        },
            "Developer Community");
    }

    public static getHelpFromOurForum() {
        return localize({
            key: "MainView.Subtitle.getHelpFromOurForum",
            comment: ["Subtitle text in main screen"]
        },
            "Get help from our community supported forum");
    }

    public static releaseAnnouncementTitle() {
        return localize({
            key: "MainView.Announcement.releaseAnnouncementTitle",
            comment: ["First tab in Announcements - Release Announcement, referring to the Release Channel"]
        },
            "Release Announcement");
    }

    public static previewAnnouncementTitle() {
        return localize({
            key: "MainView.Announcement.previewAnnouncementTitle",
            comment: ["Second tab in Announcements - Preview Announcement, referring to the Preview Channel"]
        },
            "Preview Announcement");
    }

    public static readAboutAllOurNewFeatures() {
        return localize({
            key: "MainView.Announcement.readAboutAllOurNewFeatures",
            comment: ["Text below the Announcement, directing the user to a page where they can read more about the released features"]
        },
            "Read about all our new features");
    }

    public static downloadVisualStudio() {
        return localize({
            key: "MainView.Announcement.downloadVisualStudio",
            comment: ["Text on the donwload Visual Studio button"]
        },
            "Install Visual Studio");
    }

    public static systemRequirements() {
        return localize({
            key: "MainView.Announcement.systemRequirements",
            comment: ["Text on the System Requirements link"]
        },
            "System requirements");
    }

    public static communityActivity() {
        return localize({
            key: "MainView.Announcement.communityActivity",
            comment: ["Title of the Resolved Problems section"]
        },
            "Community activity");
    }

    public static resolvedProblemsCount(resolvedProblemsCount: number, shortName: string) {
        return localize({
            key: "MainView.Announcement.resolvedProblemsCount",
            comment: ["Text showing the user the number of solved problems in this release; {0} - a number, {1} - name of release e.g. 15.5 Preview 3"]
        },
            "{0} completed feedback in {1}", resolvedProblemsCount, shortName);
    }

    public static loadingAnnouncement() {
        return localize({
            key: "MainView.Announcement.loadingAnnouncement",
            comment: ["Text showing that announcements are loading"]
        },
            "Looking for fixes...");
    }

    public static errorLoadingAnnouncement(errorMessage: string) {
        return localize({
            key: "MainView.Announcement.errorLoadingAnnouncement",
            comment: ["Text showing there's an error during loading announcements"]
        },
            "Error loading announcements: '{0}'", errorMessage);
    }

    public static loadingMyItems() {
        return localize({
            key: "MainView.MyItems.loadingMyItems",
            comment: ["Text showing that Items I follow are loading"]
        },
            "Digging through stacks to fetch your feedback");
    }

    public static errorLoadingMyItems(errorMessage: string) {
        return localize({
            key: "MainView.MyItems.errorLoadingMyItems",
            comment: ["Text showing there's an error during loading Items I follow"]
        },
            "Error loading your items: '{0}'", errorMessage);
    }

    public static titleItemsIFollow() {
        return localize({
            key: "Search.title.titleItemsIFollow",
            comment: ["Text title header"]
        },
            "Items I Follow");
    }

    public static loadingIncident() {
        return localize({
            key: "MainView.Incident.loadingIncident",
            comment: ["Text showing that incidents are loading"]
        },
            "Loading incidents...");
    }

    public static errorLoadingIncident(errorMessage: string) {
        return localize({
            key: "MainView.Incident.errorLoadingIncident",
            comment: ["Text showing there's an error during loading incidents"]
        },
            "Error loading incidents: '{0}'", errorMessage);
    }

    public static prefixIncidentText() {
        return localize({
            key: "MainView.Incident.prefixIncidentText",
            comment: ["Prefix text of the incidents section"]
        },
            "We're investigating issues that are impacting a number of our customers – ");
    }

    public static errorLoadingOutage(errorMessage: string) {
        return localize({
            key: "MainView.Outage.errorLoadingOutage",
            comment: ["Text showing there's an error during loading outage"]
        },
            "Error loading VS Status: '{0}'", errorMessage);
    }

    public static errorLoadingCustomOutage(errorMessage: string) {
        return localize({
            key: "MainView.CustomOutage.errorLoadingCustomOutage",
            comment: ["Text showing there's an error during loading custom outage"]
        },
            "Error loading custom status: '{0}'", errorMessage);
    }

    public static signInToEngage() {
        return localize({
            key: "MainView.ItemsIFollow.signInToEngage",
            comment: ["Info text"]
        },
            "Sign in to engage with the community");
    }

    public static reportNewProblemsOrEngage() {
        return localize({
            key: "MainView.ItemsIFollow.reportNewProblemsOrEngage",
            comment: ["Info text"]
        },
            "Report new problems or engage in problems submitted by others.");
    }

    public static signInProblemUseVisualStudio() {
        return localize({
            key: "MainView.ItemsIFollow.signInProblemUseVisualStudio",
            comment: ["Info text"]
        },
            "Problem signing in? Please try signing in using Visual Studio.");
    }

    public static myActivity() {
        return localize({
            key: "MainView.ItemsIFollow.myActivity",
            comment: ["Button text"]
        },
            "My Activity");
    }

    public static myFeedback() {
        return localize({
            key: "MainView.posts.myFeedback",
            comment: ["My feedback text shown in title"]
        },
            "My Feedback");
    }

    public static profileAndPreferences() {
        return localize({
            key: "MainView.header.profileAndPreferences",
            comment: ["Text for Profile and Preferences link shown in site header"]
        },
            "Profile and Preferences");
    }

    public static recentlySubmittedFeedback() {
        return localize({
            key: "MainView.posts.recentlySubmittedFeedback",
            comment: ["Message displayed to user to inform him that their recently submitted feedback will show up in few minutes"]
        },
            "Your recently submitted feedback should be available within few minutes. Please refresh this page after some time.");
    }

    public static postTypeFilter() {
        return localize({
            key: "MainView.ItemsIFollow.postTypeFilter",
            comment: ["Post type filter label"]
        },
            "Post type filter");
    }

    public static all() {
        return localize({
            key: "MainView.ItemsIFollow.all",
            comment: ["Button text"]
        },
            "All feedback");
    }

    public static features() {
        return localize({
            key: "MainView.ItemsIFollow.features",
            comment: ["Button text"]
        },
            "Features");
    }

    public static problems() {
        return localize({
            key: "MainView.ItemsIFollow.problems",
            comment: ["Button text"]
        },
            "Problems");
    }

    public static suggestions() {
        return localize({
            key: "MainView.ItemsIFollow.features",
            comment: ["Button text"]
        },
            "Feature requests");
    }

    public static myActivityNarrator(problemCount: number) {
        return localize({
            key: "MainView.ItemsIFollow.myActivityNarrator",
            comment: ["Button text. {0} - a number e.g. 48"]
        },
            "My Activity {0}", problemCount);
    }

    public static problemsNarrator(problemCount: number) {
        return localize({
            key: "MainView.ItemsIFollow.problemsNarrator",
            comment: ["Button text. {0} - a number e.g. 48"]
        },
            "Problems ({0})", problemCount);
    }

    public static suggestionsNarrator(suggestionCount: number) {
        return localize({
            key: "MainView.ItemsIFollow.suggestionsNarrator",
            comment: ["Button text. {0} - a number e.g. 48"]
        },
            "Features ({0})", suggestionCount);
    }

    public static bracketsNumber(problemCount: number) {
        return localize({
            key: "MainView.ItemsIFollow.bracketsNumber",
            comment: ["Number in brackets used for showing number of problems. {0} - a number e.g. 12"]
        },
            "({0})", problemCount);
    }

    public static actCommented(onFriendlyDate: string) {
        return localize({
            key: "General.Activity.actCommented",
            comment: ["Description of activity, 0 - date"]
        },
            "Commented on {0}", onFriendlyDate);
    }

    public static actDeleted(onFriendlyDate: string) {
        return localize({
            key: "General.Activity.actDeleted",
            comment: ["Description of activity, 0 - date"]
        },
            "Deleted on {0}", onFriendlyDate);
    }

    public static actPosted(onFriendlyDate: string) {
        return localize({
            key: "General.Activity.actPosted",
            comment: ["Description of activity, 0 - date"]
        },
            "Posted on {0}", onFriendlyDate);
    }

    public static actChangedState(onFriendlyDate: string) {
        return localize({
            key: "General.Activity.actChangedState",
            comment: ["Description of activity, 0 - date"]
        },
            "Changed state on {0}", onFriendlyDate);
    }

    public static actVoted(onFriendlyDate: string) {
        return localize({
            key: "General.Activity.actVoted",
            comment: ["Description of activity, 0 - date"]
        },
            "Voted on {0}", onFriendlyDate);
    }

    public static actGeneral(onFriendlyDate: string) {
        return localize({
            key: "General.Activity.actGeneral",
            comment: ["Description of activity, 0 - date"]
        },
            "Acted on {0}", onFriendlyDate);
    }

    public static actSolved(onFriendlyDate: string) {
        return localize({
            key: "General.Activity.actSolved",
            comment: ["Description of activity, 0 - date"]
        },
            "Solved on {0}", onFriendlyDate);
    }

    public static didSolutionWorkForYou() {
        return localize({
            key: "MainView.infoText.didItwork",
            comment: ["Explanation text"]
        },
            "Did this solution work for you?");
    }

    public static letUsKnowSolution() {
        return localize({
            key: "MainView.link.letUsKnowSolution",
            comment: ["Link text"]
        },
            "Let us know");
    }

    public static problemStartedAfterUpgrade(productName: string) {
        return localize({
            key: "ReportProblem.text.problemStartedAfterUpgrade",
            comment: ["Check box text - information about when a problem first appeared"]
        },
            "This problem started after upgrading to a new version of " + productName);
    }

    public static description() {
        return localize({
            key: "ReportProblem.problem.description.title.text",
            comment: ["Title for problem description textbox"]
        },
            "Description");
    }

    public static problemDescriptionPlaceholder() {
        return localize({
            key: "ReportProblem.problem.description.placeholder.text",
            comment: ["Placeholder for problem description textbox"]
        },
            "To increase our ability to provide a fix, please thoroughly explain the issue and add clear reproduction steps");
    }

    public static suggestionDescriptionPlaceholder() {
        return localize({
            key: "ReportProblem.suggestion.description.placeholder.text",
            comment: ["Placeholder for suggestion description textbox"]
        },
            "To help us prioritize what to work on first, please include only one feature request per suggestion");
    }

    public static optional() {
        return localize({
            key: "ReportProblem.text.optional",
            comment: ["Text for optional form fields"]
        },
            "(optional)");
    }

    public static whenDidItLastWork() {
        return localize({
            key: "ReportProblem.text.whenDidItLastWork",
            comment: ["static text"]
        },
            "What version did this last work in?");
    }

    public static whenDidItLastWork_Example() {
        return localize({
            key: "ReportProblem.text.whenDidItLastWork_Example",
            comment: ["Examples of Visual Studio version numbers, shown as placeholder text"]
        },
            "example: '17.13' or '17.14 Preview 2'");
    }

    public static selectAnOption() {
        return localize({
            key: "ReportProblem.text.selectAnOption",
            comment: ["Placeholder for dropdown menu"]
        },
            "Select an option");
    }

    public static chooseHowTheIssueAffectsYou() {
        return localize({
            key: "ReportProblem.text.chooseHowTheIssueAffectsYou",
            comment: ["Label for severity dropdown menu"]
        },
            "Choose how the issue impacts you");
    }

    public static chooseVSForMacVersion() {
        return localize({
            key: "ReportProblem.text.chooseVSForMacVersion",
            comment: ["Label for VSForMac version dropdown menu"]
        },
            "Choose the VS For Mac version you are reporting the problem for (required) :");
    }

    public static note() {
        return localize({
            key: "ReportProblem.text.attention",
            comment: ["Used for the feedback warn and notify dialog titles"]
        },
            "Note");
    }

    public static attention() {
        return localize({
            key: "ReportProblem.text.attention",
            comment: ["Used for the feedback warn and notify dialog titles"]
        },
            "Attention!");
    }

    public static mainstreamSupportEnded() {
        return localize({
            key: "ReportProblem.text.attention",
            comment: ["Used for the feedback warn and notify dialog titles"]
        },
            "Mainstream Support Ended");
    }

    public static updateRequired() {
        return localize({
            key: "ReportProblem.text.updateRequired",
            comment: ["Used for the feedback block dialog title"]
        },
            "Visual Studio Update Required");
    }

    public static updateRequiredPreview() {
        return localize({
            key: "ReportProblem.text.updateRequired",
            comment: ["Used for the feedback block dialog title"]
        },
            "Visual Studio Preview Update Required");
    }

    public static outdatedBuildFinalMinorBlock(edition: string, brand: string, fixesLink: string, supportedLink: string) {
        return localize({
            key: "ReportProblem.text.outdatedBuildFinalMinorBlock",
            comment: ["Informs user their version of VS is in extended support,  edition - edition of Visual Studio (e.g. Community), version - version of Visual Studio (e.g. 16.0), supportedLink - link to information about supported versions, fixesLink - link to our fixes page"]
        },
            "Visual Studio {0} {1} is now under <a href='{2}' target='_blank' rel='noopener noreferrer'>extended support</a>, and we are no longer reviewing feedback for it. <br> <br> We deliver <a href='{3}' target='_blank' rel='noopener noreferrer'>hundreds of improvements</a> with every release, so it's possible that your problem has already been addressed. We recommend you update to the latest Visual Studio or contact Microsoft Support Services for assistance.", edition, brand, supportedLink, fixesLink);
    }

    public static outdatedBuildBlock(edition: string, brand: string, version: string, fixesLink: string, supportedLink: string) {
        return localize({
            key: "ReportProblem.text.outdatedBuildBlocking",
            comment: ["Informs the user their version of VS is no longer being reviewed,  edition - edition of Visual Studio (e.g. Community), version - version of Visual Studio (e.g. 16.0), supportedLink - link to information about supported versions, fixesLink - link to our fixes page"]
        },
            "We are no longer reviewing feedback or providing security fixes for this release of Visual Studio {0} {1}, version {2}. <br> <br> We deliver <a href='{4}' target='_blank' rel='noopener noreferrer'>hundreds of improvements</a> with every release, so it's possible that your problem has already been addressed. Please download a <a href='{3}' target='_blank' rel='noopener noreferrer'>supported version</a> of Visual Studio {0} {1}. If your issue persists, submit a feedback ticket on that version.", edition, brand, version, supportedLink, fixesLink);
    }

    public static outdatedBuildBlockBanner(edition: string, brand: string) {
        return localize({
            key: "ReportProblem.text.buildWarnBanner",
            comment: ["Informs the user their version of VS is outdated, edition - edition of Visual Studio (e.g. Community),brand - the brand of Visual Studio (e.g. 2019), version - version of Visual Studio (e.g. 16.0)"]
        },
            "We are no longer reviewing feedback for this release of Visual Studio {0} {1}", edition, brand);
    }

    public static outdatedBuildWarn(edition: string, brand: string, version: string, fixesLink: string, supportedLink: string) {
        return localize({
            key: "ReportProblem.text.outdatedBuildWarning",
            comment: ["Warns the user that their version of VS is not fully supported, edition - edition of Visual Studio (e.g. Community), brand - the brand of Visual Studio (e.g. 2019), version - version of Visual Studio (e.g. 16.0), supportedLink - link to information about supported versions, fixesLink - link to our fixes page"]
        },
            "This release of Visual Studio  {0} {1}, version {2}, is <a href='{3}' target='_blank' rel='noopener noreferrer'>not fully supported</a>, and we are no longer providing fixes for it. <br> <br> We deliver <a href='{4}' target='_blank' rel='noopener noreferrer'>hundreds of improvements</a> with every release, so it's possible that your problem has already been addressed. Please download the latest version now, and, if your issue persists, submit a feedback ticket on that version. ", edition, brand, version, supportedLink, fixesLink);
    }

    public static outdatedBuildWarnBanner(edition: string, brand: string) {
        return localize({
            key: "ReportProblem.text.buildWarnBanner",
            comment: ["Warns the user that their version of VS is not fully supported, edition - edition of Visual Studio (e.g. Community), brand - the brand of Visual Studio (e.g. 2019)."]
        },
            "This version of Visual Studio {0} {1} is no longer fully supported.", edition, brand);
    }

    public static outdatedBuildNotify(edition: string, brand: string, fixesLink: string) {
        return localize({
            key: "ReportProblem.text.outdatedBuildNotify",
            comment: ["Notifies the user that a new version of VS is availabe, edition - edition of Visual Studio (e.g. Community), brand - brand of Visual Studio (e.g. 2019), fixesLink - link to our fixes page"]
        },
            "A newer release of Visual Studio {0} {1} is available. We deliver <a href='{2}' target='_blank' rel='noopener noreferrer'>hundreds of improvements</a> with every release, so it's possible that your problem has already been addressed.  You can continue to submit your issue, or update to the latest Visual Studio to see if your issue is fixed before submitting a ticket.", edition, brand, fixesLink);
    }

    public static outdatedBuildNotifyBanner(edition: string, brand: string) {
        return localize({
            key: "ReportProblem.text.outdatedBuildNotifyBanner",
            comment: ["Banner to notify the user that a new version is available,  edition - edition of Visual Studio (e.g. Community),brand - the brand of Visual Studio (e.g. 2019),"]
        },
            "A newer version of Visual Studio {0} {1} is available.", edition, brand);
    }

    public static outdatedBuildBlockPreview(edition: string, brand: string, version: string) {
        return localize({
            key: "ReportProblem.text.outdatedBuildBlockingPreview",
            comment: ["Informs the user that their version of VS Preview is no longer under review, edition - edition of Visual Studio (e.g. Community), brand - the brand of Visual Studio (e.g. 2019), version - version of Visual Studio (e.g. 16.0)"]
        },
            "We are no longer reviewing feedback on {0} {1} version {2}. We recommend updating to the latest preview before submitting your feedback.", edition, brand, version);
    }

    public static outdatedBuildBlockPreviewBanner(edition: string, brand: string) {
        return localize({
            key: "ReportProblem.text.buildWarnPreviewBanner",
            comment: ["Informs the user that ta newer version of VS is available, edition - edition of Visual Studio (e.g. Community), brand - the brand of Visual Studio (e.g. 2019)"]
        },
            "A newer version of Visual Studio {0} {1} Preview is available.", edition, brand);
    }

    public static outdatedBuildWarnPreview(edition: string, brand: string, version: string) {
        return localize({
            key: "ReportProblem.text.outdatedBuildWarningPreview",
            comment: ["Warns the user that their preview version of VS is out of development, edition - edition of Visual Studio (e.g. Community), brand - the brand of Visual Studio (e.g. 2019), version - version of Visual Studio (e.g. 16.0)"]
        },
            "A newer version of Visual Studio {0} {1} Preview is available, and this version of Visual Studio {0} {1} Preview is no longer in development. Please update to the latest preview version to get the most recent changes. We recommend updating to the latest Preview before submitting your feedback.", edition, brand, version);
    }

    public static outdatedBuildWarnPreviewBanner(edition: string, brand: string) {
        return localize({
            key: "ReportProblem.text.buildWarnPreviewBanner",
            comment: ["Informs the user that ta newer version of VS is available, edition - edition of Visual Studio (e.g. Community), brand - the brand of Visual Studio (e.g. 2019)."]
        },
            "A newer version of Visual Studio {0} {1} Preview is available.", edition, brand);
    }

    public static outdatedBuildNotifyPreview(edition: string, brand: string) {
        return localize({
            key: "ReportProblem.text.outdatedBuildNotifyPreview",
            comment: ["Notifies the user that a new version of VS Preview is availabe, edition - edition of Visual Studio (e.g. Community), brand - brand of Visual Studio (e.g. 2019), fixesLink - link to our fixes page"]
        },
            "A newer version of Visual Studio {0} {1} Preview is available. Please update to the latest preview version to get the most recent changes.", edition, brand);
    }

    public static outdatedBuildNotifyPreviewBanner(edition: string, brand: string) {
        return localize({
            key: "ReportProblem.text.buildNotifyPreviewBanner",
            comment: ["Banner to notify the user that a new version is available,  edition - edition of Visual Studio (e.g. Community), brand - the brand of Visual Studio (e.g. 2019)"]
        },
            "A newer version of Visual Studio {0} {1} Preview is available.", edition, brand);
    }
}


